import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Gallery from './components/gallery/colorfuel-opensea/Gallery.tsx';
import GalleryOverviewPage from './components/gallery/overview/GalleryOverviewPage.tsx';
// import GalleryExplorePage from './components/gallery/explore/GalleryExplorePage.tsx';
import HeaderBar from './components/header/header-bar/HeaderBar.tsx';
import PicturePage from './components/picture/ethereum/PicturePage';
// import SolanaPicturePage from './components/picture/solana/SolanaPicturePage';
import FooterBar from './components/footer/footer-bar/FooterBar';
import AboutPage from './components/about/AboutPage';
import ScrollToTop from './helpers/ScrollToTop';
import SimulationGalleryPage from './components/3dgallery/SimulationGalleryPage';
import MintingPage from './components/minting/MintingPage';
// import SolanaNFTMinting from './components/minting/solana/nftMinting/SolanaNFTMinting';
// import SolanaCollectionMinting from './components/minting/solana/collectionMinting/SolanaCollectionMinting';
import FrontPage from './components/home/FrontPage';
import TermsPage from './components/terms/TermsPage';
import PrivacyPage from './components/privacy/PrivacyPage';
//import PrintPage from './components/print/PrintPage';
//import CartPage from './components/shopping/cart/CartPage';
import React from 'react';
//import { CartProvider } from './components/shopping/cart/CartContext';
//const CheckoutPage = React.lazy(() => import('./components/shopping/checkout/CheckoutPage'));

function App() {
  return (
    //<CartProvider>
      <div className="App">
        <HeaderBar/>
        <night-sky
          id="nightSky"
          layers="4"
          density="30"
          velocity="60"
          starcolor="#0CF">
        </night-sky>
        <Routes>
          <Route exact path="/" element={<FrontPage />} />
          <Route exact path="/discover" element={<GalleryOverviewPage />} />
          <Route exact path="/discover/ethereum" element={<Gallery />} />
          <Route exact path="/discover/ethereum/nft/:name" element={<PicturePage />}/>
          {/* <Route exact path="/discover/solana" element={<GalleryExplorePage />} /> */}
          {/* <Route exact path="/discover/solana/nft/:id" element={<SolanaPicturePage />}/> */}
          <Route exact path="/3dgallery" element={<SimulationGalleryPage />} />
          <Route exact path="/about" element={<AboutPage />} />
          <Route exact path="/nft/:name" element={<PicturePage />}/>
          {/*<Route exact path="/nft/:name/print" element={<PrintPage />}/>*/}
          <Route exact path="/create" element={<MintingPage />}/>
          {/* <Route exact path="/create/solana-nft" element={<SolanaNFTMinting />}/> */}
          {/* <Route exact path="/create/solana-collection" element={<SolanaCollectionMinting />}/> */}
          <Route exact path="/terms" element={<TermsPage />} />
          <Route exact path="/privacy" element={<PrivacyPage />} />
          {/*<Route exact path="/cart" element={<CartPage />} />*/}
          {/*<Route exact path="/checkout" element={<React.Suspense fallback={<div>Loading...</div>}><CheckoutPage /></React.Suspense>} />*/}
          <Route exact path="/" element={<Navigate to="/" />}/>
          <Route path="*" element={<Navigate to="/" />}/>
        </Routes>
        <FooterBar/>
        <ScrollToTop />
      </div>
    //</CartProvider>
  );
}

export default App;
